"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stage = exports.StageType = void 0;
var StageType;
(function (StageType) {
    StageType["Local"] = "local";
    StageType["Develop"] = "develop";
    StageType["Beta"] = "beta";
    StageType["Preview"] = "preview";
    StageType["Prod"] = "prod";
    StageType["ProdAlt"] = "prod-alt";
})(StageType = exports.StageType || (exports.StageType = {}));
class Stage {
    constructor(type, devPrefix) {
        this.type = type;
        this.devPrefix = devPrefix;
    }
    get isLocal() {
        return this.type === StageType.Local;
    }
    get isDevelop() {
        return this.type === StageType.Develop;
    }
    get isBeta() {
        return this.type === StageType.Beta;
    }
    get isProd() {
        return this.type === StageType.Prod || this.type === StageType.ProdAlt;
    }
    static fromEnvironment(options) {
        var _a, _b, _c, _d;
        const stageTypeEnv = (((_d = (_c = (_b = process.env[(_a = options === null || options === void 0 ? void 0 : options.stageTypeKey) !== null && _a !== void 0 ? _a : ""]) !== null && _b !== void 0 ? _b : process.env["STAGE_TYPE"]) !== null && _c !== void 0 ? _c : process.env["NODE_ENV"]) !== null && _d !== void 0 ? _d : StageType.Local));
        const stageType = Object.values(StageType).includes(stageTypeEnv) ? stageTypeEnv : StageType.Local;
        const devPrefix = stageType === StageType.Local ? process.env["DEV_PREFIX"] : undefined;
        return new Stage(stageType, devPrefix);
    }
    static fromParts(stageType, devPrefix) {
        return new Stage(stageType, devPrefix);
    }
    toString() {
        var _a;
        return this.type + (this.isLocal ? `(devPrefix=${(_a = this.devPrefix) !== null && _a !== void 0 ? _a : "UNDEFINED"})` : "");
    }
    toCanonicalStage() {
        return this.type === StageType.ProdAlt ? StageType.Prod : this.type;
    }
}
exports.Stage = Stage;
//# sourceMappingURL=Stage.js.map